import axios from 'axios'
import qs from 'qs'
import { storage, cookie } from '~/common/utils/storage'
import { Message } from 'element-ui'

// 全局配置
axios.defaults.headers['Content-Type'] = 'application/json; charset=utf-8'
// 创建新axios实例
const _axios = axios.create({
  timeout: 30000
})
// 创建Map实例
let pending = new Map()

/**
 * 添加请求
 * @param {Object} config
 */
const addPending = config => {
  const url = [config.method, config.url, qs.stringify(config.params), qs.stringify(config.data)].join('&')
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken(cancel => {
      if (!pending.has(url)) {
        // 如果 pending 中不存在当前请求，则添加进去
        pending.set(url, cancel)
      }
    })
}

/**
 * 移除请求
 * @param {Object} config
 */
const removePending = config => {
  const url = [config.method, config.url, qs.stringify(config.params), qs.stringify(config.data)].join('&')
  if (pending.has(url)) {
    // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
    const cancel = pending.get(url)
    cancel(url)
    pending.delete(url)
  }
}

// 响应错误回调
const errHandler = error => {
  if (axios.isCancel(error)) {
    console.log('Request canceled: ' + error.message)
  } else {
    const _error = error.response
    if (_error) {
      handleErrorCode(error)
    } else {
      Message.error('网络异常，请稍后再试！')
    }
  }

  return Promise.reject(error)
}

// 处理各种异常状况
function handleErrorCode(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '错误请求'
        break
      case 401:
        err.message = '未授权，请重新登录'
        break
      case 403:
        err.message = '拒绝访问'
        break
      case 404:
        err.message = '请求错误，未找到该资源'
        break
      case 405:
        err.message = '请求方法未允许'
        break
      case 408:
        err.message = '请求超时'
        break
      case 500:
        err.message = '服务器端出错'
        break
      case 501:
        err.message = '网络未实现'
        break
      case 502:
        err.message = '网络错误'
        break
      case 503:
        err.message = '服务不可用'
        break
      case 504:
        err.message = '网络超时'
        break
      case 505:
        err.message = 'http版本不支持该请求'
        break
      default:
        err.message = `连接错误${err.response.status}`
    }
    const errData = {
      code: err.response.status,
      message: err.message
    }
    Message.error(err.message)
    // 统一错误处理，例如页面提示错误...
    console.log('统一错误处理: ', errData)
  }
}

// 请求拦截
_axios.interceptors.request.use(config => {
  // 设置sessionToken
  let sessionToken = '',lang = '';
  config.url = config.url.startsWith("/") ? config.url : "/" + config.url
  sessionToken = storage.get('session_token') || storage.get('session_token', true)
  config.headers['X-Session-Token'] = sessionToken || ''
  lang = storage.get('lang');
  config.headers['Lang'] = config.headers['Lang'] ? config.headers['Lang'] : lang || '';
  // 内容域的接口加上商户id，其它域暂时不用
  if (config.url.includes('/cms')) {
    try {
      config.headers['shop-id'] = storage.get('profile').latest_shop_id || ''
    } catch (error) { }
  }
  if(process.client) {
    const uuid = storage.get('visit_uuid')
    if(uuid) {
      config.headers['uuid'] = uuid
    }
  }
  
  removePending(config) // 请求开始前，对之前的请求做检查取消操作
  addPending(config) // 将当前请求添加到pending中
  return config
}, errHandler)

// 响应拦截
let flag = true;
_axios.interceptors.response.use(res => {
  removePending(res.config) // 请求结束后，移除本次请求

  const result = res.data
  let _showNotify = true
  if ('showNotify' in res.config.headers) _showNotify = res.config.headers['showNotify']
  
  if (res.headers['content-type']?.includes('text/html')) {
    return result
  } else if (result.type === "application/octet-stream" || result.type === "application/pdf" || (result.type && result.type.includes('application/json'))) {
    if(result.type.includes('application/json')) {
      let reader = new FileReader()
      reader.readAsText(res.data, 'utf-8')
      reader.onload = () => {
        const { msg } = JSON.parse(reader.result)
        Message.error(msg)
      }
      return result
    }
    return res
  } 
  else if(/visit\/create/.test(res.config.url)) {
    console.log('埋点不需要主动报错')
  }
  else if (result.code == 401) {
    if (flag) {
      flag = false;
      storage.rm('session_token')
      storage.rm('session_token', true)
      cookie.rm('auth')
      let routeArr = process.env.PROJECT_NAME === 'content' ? ['/content/view/questionnaire', '/content/view/invitation'] : ['/srvContent/view']
      flag = routeArr.some(item => {
        return window.location.pathname.includes(item)
      })
      if (flag) {
        window.location.reload()
      } else {
        window.location.href= window.location.origin
      }
      setTimeout(function () {
        flag = true
      }, 3000)
      return result
    }
  } else if (result.code == 403 || result.code == 400) {
    Message({
      message: result.msg,
      type: 'error'
    })
    return result
  } else if (result.code == 500) {
    let tip = ''
    if(/\\n/.test(result.msg)) {
      let arr = result.msg.split('\\n')
      arr.map(item => {
        if(item) {
          const tmp = `<p style="margin-bottom: 3px">${item}</p>`
          tip += tmp
        }
      })
    } else {
      tip = result.msg
    }
    Message({
      message: tip,
      duration: 3000,
      dangerouslyUseHTMLString: true,
      type: 'error'
    })
  } else if (result.code !== 200) {
    if (_showNotify) {
      Message({
        message: result.msg,
        type: 'error'
      })
    }
    return false
  }
  return result
}, errHandler)

const service = opt => {
  return new Promise((resolve, reject) => {
    const { url, method, data, ...config } = opt
    const params = {
      url,
      method,
      [method.toLowerCase() == 'get' ? 'params' : 'data']: data || {},
      ...config
    }

    _axios(params)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 清空 pending 中的请求（在路由跳转时调用）
 */
export const clearPending = () => {
  for (const [url, cancel] of pending) {
    cancel(url)
  }
  pending.clear()
}
export { service as axios }
